import React from "react";
// import WorkingFormat from "./workingformat.png";
// import salaryStatics from "./salarystatics.png";
// import staffTurnover from "./Staffturnover.png";
// import totalProject from "./totalproject.png";
// import top3dept from "./top3dept.png";
// import onboardingStatus from "./onboardingstatus.png";
import "./HRDashboard.css";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import NavBar from "../NavBar";
import { Button } from "@mui/material";
import {ReqProTable} from './HRComponent/Table'
import {RecruitmentProcessData ,RecPrHeading,title} from './HRData/ReqProData'
import {title2,data,heading} from './HRData/topEmployeeData';
import Chart from './HRComponent/LineChart';
import HREmployeeData from './HRData/HREmployeeData';
import PieCircle from './HRComponent/piechart';
import BarChart from './HRComponent/barchart';
import Demo from '../demo.js'
import DotsComponent from "../DotsComponent";
import MiniCards from "./HRComponent/MiniCards";
import {miniData1, miniData2} from "../MiniData";
import HRProjectCard from "./HRComponent/HRProjectCard";
import { ProjectsData, RequestsData } from "../HRData";

export default function HRDashboard() {
  return (
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="account_title">Human Resource Management </span>
          <span className="color"> &#62; </span>
          <span className="color"> Dashboard </span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h1>Dashboard</h1>
        <div id="Right-content-Down-Filters">
      <Button variant="outlined" style={{backgroundColor:'#4E6DCB',color:'#fff'}} startIcon={<AddCircleOutlineIcon />}>
            Add Recruitment
          </Button>
          <Button variant="outlined" style={{backgroundColor:'#4E6DCB',color:'#fff'}} startIcon={<AddCircleOutlineIcon />}>
            Add an employee
          </Button>
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "60%",
            }}
          ></div>
        </div>
      </div>
      <div id="hr-parent-div">
        <div id="hr-div-child1" className="hrChild">
          <div id="hr-child1-left" className="hrChildLeft">
            <MiniCards data={miniData1}/>
            <div id="hr-child1-left-dn" className="hrChildLeftdn">
              <div id="hr-Child1-left-dn1" className="hrChildLeftdndiv">
                  <div>
                  <DotsComponent/>
                  <h3>
                    WORKING FORMAT
                  </h3>
                    <Demo/>
                  </div>
                {/* <img src={WorkingFormat} alt="" /> */}
              </div>
              <div id="hr-Child1-left-dn2" className="hrChildLeftdndiv">
                {/* <img src={staffTurnover} alt="" /> */}
                <DotsComponent/>
                <h3>STAFF TURNOVER</h3>
                <BarChart/>
              </div>
              <HRProjectCard data={RequestsData} hardData={RequestHardData}/>

            </div>
          </div>
          <div id="hr-child1-right" className="hrChildRight">
            {/* <img src={onboardingStatus} alt="" /> */}
            <DotsComponent/>
            <h3 style={{paddingTop:'20px'}}>ONBOARDING STATUS</h3>
            <PieCircle/>
          </div>
        </div>
        <div id="hr-div-child2" className="hrChild">
          <div className="hrChildLeft" id="hr-div-child2-left" >
            {/* <img src={salaryStatics} alt="" width={'100%'} height={"100%"} /> */}
            <Chart/>
          </div>
          <div className="hrChildRight" id="hr-div-child2-right">
          <ReqProTable props={RecruitmentProcessData} heading={RecPrHeading} title={title}/>
            
          </div>
        </div>
        <div id="hr-div-child3" className="hrChild">
          <div id="hr-child3-left" className="hrChildLeft">
           <MiniCards data={miniData2}/>
            <div id="hr-child3-left-dn" className="hrChildLeftdn">
              <div id="hr-Child3-left-dn1" className="hrChildLeftdndiv">
              <DotsComponent/>
              <h3>TOTAL PROJECTS</h3>
                  <Demo/>
                {/* <img src={totalProject} alt="" /> */}
              </div>
              <div id="hr-Child3-left-dn2" className="hrChildLeftdndiv">
              <ReqProTable props={data} heading={heading} title={title2}/>

              </div>
          <HRProjectCard data={ProjectsData} hardData={ProjectHardData}/>
            </div>
          </div>
          <div id="hr-child3-right" className="hrChildRight">
            {/* <img src={top3dept} alt="" /> */}
            <DotsComponent/>
            <h3 style={{paddingTop:'20px'}}>TOP 3 DEPARTMENTS</h3>
            <PieCircle/>
          </div>
        </div>
      </div>
    </>
  );
}
const ProjectHardData = {
  title:'PROJECTS',
  para1: 'Received Request',
  para2:'Completed',
  para3:'In progress',
  para4:'Rejected Projects'
}
const RequestHardData = {
  title:'REQUESTS',
  para1: 'Profile update',
  para2:'Bussiness trips',
  para3:'Vacations',
  para4:'Sick leaves'
}

export const topEmployeesData = [
  { fName: "Ellie Clinton", dept: "Content Writer", proj_fin: "Interview" },
  { fName: "Ellie Clinton", dept: "Content Writer", proj_fin: "Resume" },
  { fName: "Ellie Clinton", dept: "Content Writer", proj_fin: "Task Assigned" },
];
